import { ZINGLE_DEMO, ZINGLE_ANDROIDID , ZINGLE_IOSID } from "../../../config/constant"
import { freshChatData } from "../../../reducers/channelReducer"

export const zingleWidgetInitialize = (props, callback) => {

    const { t } = props;
    let room = localStorage.getItem("room");
    let checkedInGuestInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    console.log("Zingle Interface initialized")
    if (window.Smooch){
        let platform = window.device.platform

        if(platform == "Android"){
            window.Smooch.init(props.freshChatData.login.androidIntegrationId)
        } else if ( platform == "iOS" ) {
            window.Smooch.init({
                "appId" : props.freshChatData.login.iosIntegrationId
          });
        }else {
            console.log("Zingle cannot be init in browser")
        }

        if(room && room != "null"){

            if (checkedInGuestInfo && checkedInGuestInfo[0]){
                if(window.device && window.Smooch){


                    let userData = {
                        "firstName" : checkedInGuestInfo[0].guestProfile.firstName,
                        "lastName" : checkedInGuestInfo[0].guestProfile.lastName,
                        "email" : checkedInGuestInfo[0].guestProfile.email,
                    }

                    window.Smooch.setUser(userData);


                    let metaData = {
                      [t('zingleMetaDataKey.room')]: localStorage.getItem("room"),
                      [t('zingleMetaDataKey.profile_id')]: checkedInGuestInfo[0].guestProfile.pmsProfileId,
                      [t('zingleMetaDataKey.confirmation_number')] : checkedInGuestInfo[0].reservationNumber
                    }

                    window.Smooch.setUserProperties(metaData)
                }

            setTimeout(() => {
                window.Smooch.getUserProperties((userMetaData) => {
                    console.log("Zingle User metadata" + JSON.stringify(userMetaData))
                    if(userMetaData && Object.keys(userMetaData).length !== 0){
                        if(props.freshChatData.login.startConverastionMsg) window.Smooch.createConversation(props.freshChatData.login.startConverastionMsg)
                    }
                })
            }, 4000);
        }}

        props.setChatWidgetInnitialized(true)
        callback(true)
    } else {
        callback(true)
        console.log("Zingle Plugin not found")
    }
}


export const zingleWidgetShowConversation = (props) => {
    if(window.Smooch){
        console.log("Zingle show called")
        window.Smooch.show();
        window.Smooch.getUserProperties((userMetaData) => {
            console.log("calling Zingle getUserProperties" + JSON.stringify(userMetaData))
        }, () => console.log("Zingle: something went wrong while getting user Properties"))
    } else {
        console.log("zingle Plugin not found")
    }
}